/* React Higher Order Component which fetches activity data for project where activityId = props.activityId
    Child (InnerComponent) will only render once activity data is successfully fetched.
    child will receive props: {
        activityId: PropTypes.number,
        fatalError: PropTypes.object,
        activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activity: PropTypes.object, activitySaves: PropTypes.object, ... })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    forceRefreshOnMount: PropTypes.bool, // force refresh of activity data, even if activity store already has data for the given id
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withActivityData(WrappedComponent) {
    class WithActivityData extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                getActionId: null,
                fatalError: null
            }

            this.getActData = this.getActData.bind(this);
            this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            if (
                !ActivityStore.getStateActivity(this.props.activityId, this.props.projectId, this.props.channelId).initialized
                || this.props.forceRefreshOnMount
            ) {
                this.getActData(this.props.channelId, this.props.projectId, this.props.activityId);
            }
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (
                this.props.channelId !== nextProps.channelId
                || this.props.projectId !== nextProps.projectId
                || this.props.activityId !== nextProps.activityId
            ) {
                const newActStoreState = ActivityStore.getStateActivity(nextProps.activityId, nextProps.projectId, nextProps.channelId);
                if (!newActStoreState.initialized || this.props.forceRefreshOnMount) {
                    this.getActData(nextProps.channelId, nextProps.projectId, nextProps.activityId);
                }
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(unsubscribeCallback => unsubscribeCallback());
        }

        getActData(channelId, projectId, activityId) {
            const actionId = uuid.v4();
            this.setState({ getActionId: actionId }, () => {
                ActivityActions.getActivity(actionId, { activityId: activityId, projectId: projectId, channelId: channelId });
            });
        }

        onActivityStoreChange(newState) {
            let updatedState = {};

            if (newState.action.id === this.state.getActionId) {
                updatedState = { ...updatedState, getActionId: null };
                if (!!newState.action.error) {
                    updatedState = { ...updatedState, fatalError: newState.action.error };
                }
            }

            this.setState({
                ...updatedState,
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace={false}/>;
            }

            const activityStoreState = ActivityStore.getStateActivity(this.props.activityId, this.props.projectId, this.props.channelId);
            if (!activityStoreState.initialized) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }
            else {
                if (!activityStoreState.activity) {
                    return <ErrorBox error={{ message: Strings['en'].error.NOT_FOUND_ACTIVITY }} />;
                }
            }

            return (
                <WrappedComponent
                {...this.props}
                activityStoreState={activityStoreState}
                />
            );
        }
    }

    WithActivityData.propTypes = propTypes;
    WithActivityData.defaultProps = defaultProps;
    WithActivityData.displayName = `WithActivityData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithActivityData;
}
